
import axios from "axios";
import URL from "../../helpers/URL";
import configuration from "./configuration";


export const createAppointment = (data: any) => {
    let config = configuration();
    return axios.post(URL.createAppointment, data, config);
};

export const getAppointment = (id:any)=> {
  let config = configuration();
  return axios.get(URL.getAppointment+id, config);
}

export const getAppointments = ()=> {
  let config = configuration();
  return axios.get(URL.getAppointments, config);
}

export const getVitals = ()=> {
    let config = configuration();
    return axios.get(URL.getVitals, config);
  }

